export const TEXTS_GAUGE_YEAR = {
  es_ES: new Map([
    [
      'chartUsuarisTotalsGaugeYear',
      'USO DE EMT. USUARIOS TOTALES: ÚLTIMOS AÑOS',
    ],
  ]),
  ca_ES: new Map([
    ['chartUsuarisTotalsGaugeYear', "US D'EMT. USUARIS TOTALS: ÚLTIMS ANYS"],
  ]),
};
export const TEXTS_GAUGE_MONTH = {
  es_ES: new Map([
    [
      'chartUsuarisTotalsGaugeMonth',
      'USO DE EMT. USUARIOS TOTALES: MES ACTUAL',
    ],
    [
      'chartUsuarisTotalsGaugeLastMonth',
      'USO DE EMT. USUARIOS TOTALES: MES ANTERIOR',
    ],
  ]),
  ca_ES: new Map([
    ['chartUsuarisTotalsGaugeMonth', "ÚS D'EMT. USUARIS TOTALS: MES ACTUAL"],
    [
      'chartUsuarisTotalsGaugeLastMonth',
      "ÚS D'EMT. USUARIS TOTALS: MES ANTERIOR",
    ],
  ]),
};
